import Modal from "../../../global/Modal";

import AddReferralForm from "./AddReferralForm";

export default function AddReferralModal({ caseId, open, onClose, onSubmit }) {
  return (
    <Modal open={open} onClose={onClose} maxWidth="xl">
      <div className="p-2">
        <AddReferralForm caseId={caseId} submit={onSubmit} />
      </div>
    </Modal>
  );
}
